import { render, staticRenderFns } from "./HeaderNavigationComponent.vue?vue&type=template&id=5a14b8a7&scoped=true&"
import script from "./HeaderNavigationComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigationComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNavigationComponent.vue?vue&type=style&index=0&id=5a14b8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14b8a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a14b8a7')) {
      api.createRecord('5a14b8a7', component.options)
    } else {
      api.reload('5a14b8a7', component.options)
    }
    module.hot.accept("./HeaderNavigationComponent.vue?vue&type=template&id=5a14b8a7&scoped=true&", function () {
      api.rerender('5a14b8a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/HeaderNavigationComponent.vue"
export default component.exports